export default {
  webLive_single_viewing: '單人觀看',
  webLive_many_viewing: '多人觀看',
  webLive_scanned_code: '已掃碼人數：{length}人',
  webLive_zhiniao_scan: "知鳥APP - 掃一掃",
  webLive_start_live: '開始觀看直播',
  webLive_select_view: '請選擇觀看模式',
  webLive_start_live: '開始觀看直播',
  webLive_address: "地址：",
  webLive_telephone: '電話：',
  webLive_please_ID: '請輸入直播間ID和直播間口令',
  webLive_shibboleth_rules: '直播間口令為6-10位的數字或字母',
  webLive_portal_watch: '智門戶僅支持觀看，請使用知鳥PC端登錄',
  webLive_studio_ID: '直播間ID：',
  webLive_enter_ID: '請輸入直播間ID',
  webLive_live_password: '直播間口令：',
  webLive_enter_password: "請輸入直播間口令",
  webLive_password_Room: '進入口令直播間',
  webLive_portal_live03: '03Web-智門戶直播',
  webLive_show_list03: '0301Web-顯示直播列表',
  webLive_check_live0302: '0302Web-查看直播',
  webLive_studio_fulled: '直播間已滿員',
  webLive_select_failed: '查詢失敗，請稍後再試',
  webLive_noreplay: "還沒有回放",
  webLive_noLive: "還沒有直播",
  webLive_chat: '聊天',
  webLive_new_message: "有新消息",
  webLive_failed_video: '網絡異常，獲取視頻失敗，請檢查網絡後重試',
  webLive_error_get_data: '獲取數據出錯，請稍後再試',
  webLive_data_wrong: '數據有誤',
  webLive_last_one: '已經是最後一個啦~',
  webLive_guangdong: '廣東省',
  webLive_shenzhen: '深圳市',
  webLive_nanshan: '南山區',
  webLive_studio_deleted: '直播間被刪除',
  webLive_vr_app: "vr直播請移步知鳥app觀看",
  webLive_without_power: '沒有權限進入',
  webLive_go_app_learn: '該直播間已開啟監學，請進入知鳥app進行學習',
  webLive_current_broadcast: "當前直播{liveStatusName}",
  webLive_broadcast_paid: "該直播為付分直播，請登錄知鳥APP付費後觀看",
  webLive_live_pages08: '08Web-直播間頁',
  webLive_show_pages0801: '0801Web-顯示直播間頁',
  webLive_tourist: '遊客',
  webLive_unlock: '開啟',
  webLive_switch_video: '切換視頻',
  webLive_hide_window: '隱藏小窗口',
  webLive_show_window:'顯示小窗口',
  webLive_public_announcement: '公告',
  webLive_anchor_head_sculpture: '主播頭像',
  webLive_studio_anchor: '主播:',
  webLive_audience: '觀眾：',
  webLive_check_out:'簽出',
  webLive_check_in:'簽到',
  webLive_focus_on_watch:'集中觀看',
  webLive_scan_code:'掃碼',
  webLive_calculatew_time:'{panelText}後，{flag}計算觀看時長',
  webLive_left_scan:'知鳥APP-左上角掃一掃',
  webLive_scanede_num:'已掃碼人數：{ userList.length }人',
  webLive_playback_deleted:'回放已刪除',
  webLive_playback_ended:'回放已結束',
  webLive_not_send_empty:'請勿發送空消息',
  webLive_send_interactive0803:'0803Web-發送互動',
  webLive_send_message:'發消息',
  webLive_studio_forbidden_speak:'該直播間禁止發言',
  webLive_speak:'快和主播一起互動吧',
  webLive_send_bntn:'發送',
  webLive_play_error:'如直播/回放視頻無法觀看，請切換至最新版本的IE瀏覽器登錄觀看。',
  webLive_not_support_hls:'當前瀏覽器不支持hls',
  webLive_Esc_quit:'按Esc或雙擊退出全屏',
  webLive_shrink:'縮小',
  webLive_click_zoom0802:'0802Web-點擊縮放',
  webLive_lianmai:'連麥',
  webLive_no_lianmai:'暫無連麥',
  webLive_voice_playing:"語音播放中",
  webLive_failed_get_playback:'網絡異常，獲取直播回放視頻失敗，請檢查網絡後重試',
  webLive_zhiniao_school:'知鳥|學堂',
  webLive_anchor_out:'主播暫時不在',
  webLive_play_btn:'播放按鈕',
  webLive_volume:'音量',
  webLive_full_screen:'全屏',
  webLive_enlarge:'放大',
  webLive_got_it:'知道了',
  webLive_version_too_low:'你的瀏覽器版本太低，請先升級瀏覽器。',
  webLive_will_quit_learning:'已達培訓項目結束時間即將退出學習',
  webLive_failed_punch_in:'打卡失敗',
  webLive_validation_failed:'驗證失敗',
  webLive_code_no_exit:'二維碼地址不存在！',
  webLive_upload:'下載到本地',
  webLive_count_time:"確定（{countTime}）",
  webLive_stop:'停止',
  webLive_start:"開始",
  webLive_pay: '該直播為付費直播，請前往app觀看',
  webLive_live: '直播',
  webLive_course: '課程',
  webLive_card_status:'學習卡{status}',
  webLive_payed_course:'已購課程'
}
